import './MainPage.scss'

import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import { useQuery } from '@tallink/more-react-hooks'
import qs from 'query-string'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import { useHistory, useLocation } from 'react-router-dom'
import { useEffectOnce, useMedia } from 'react-use'

import { initMainPage } from '../actions/actions'
import Booking from '../components/booking/Booking'
import Loader from '../components/common/Loader'
import Layout from '../components/layout/Layout'
import MainContent from '../components/layout/MainContent'
import UnsuccessfulPaymentCallout from '../components/Payment/UnsuccessfulPaymentCallout'
import SerialTicketHero from '../components/SerialTicketHero/SerialTicketHero'
import Sso from '../components/Sso/Sso'
import StickyFooter from '../components/StickyFooter/StickyFooter'
import Summary from '../components/Summary/Summary'
import { hasSelectedTickets, hasSerialTickets } from '../selectors/selectors'
import { GIFT_CARDS, SERIAL_TICKETS } from '../utils/mode'

export default function MainPage() {
  const { t } = useTranslation()
  const smUp = useMedia(mediaQueries.smUp)
  const dispatch = useDispatch()
  const serialTicketsLoaded = useSelector(hasSerialTickets)
  const serialTicketsSelected = useSelector(hasSelectedTickets)
  const history = useHistory()
  const location = useLocation()
  const [paymentRejected] = useState(useQuery('backendError') === 'paymentRejected')
  const [paymentCancelled] = useState(useQuery('backendError') === 'paymentCancelled')
  const code = useQuery('code')
  const amount = useQuery('amount')
  const mode = matchPath(location.pathname, { path: '/giftcards' }) ? GIFT_CARDS : SERIAL_TICKETS

  useEffectOnce(() => {
    history.replace(history.location.pathname + qs.exclude(history.location.search, ['backendError']))
  })

  useEffect(() => {
    if (!serialTicketsLoaded) {
      dispatch(initMainPage(mode, { code, amount }))
    }
  }, [dispatch, mode, serialTicketsLoaded, code, amount])

  return (
    <Layout pageTitle={t(`mainPage.title.${mode}`)}>
      {!serialTicketsLoaded && <Loader />}
      {paymentRejected || paymentCancelled ? (
        <section className="main-page callout-placeholder">
          <UnsuccessfulPaymentCallout
            title={t(paymentCancelled ? 'payment.cancelled.title' : 'payment.unsuccessful.title')}
          />
        </section>
      ) : (
        <SerialTicketHero />
      )}
      {!smUp && <Sso />}
      <section className="main-page">
        <MainContent aside={smUp && <Summary />} main={<Booking />} />
      </section>
      {serialTicketsSelected && <StickyFooter />}
    </Layout>
  )
}
